import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=0592806a&scoped=true"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0592806a",
  null
  
)

export default component.exports